'use strict';

wbApp.controller('InvoicesDetailCtrl', ['$scope', 'invoiceSvc',
function ($scope, invoiceSvc) {
     $scope.model = invoiceSvc.getByID($scope.invoiceID);
}]);
